import { render, staticRenderFns } from "./ChartPeriodMenu.vue?vue&type=template&id=4ffd79a2&scoped=true"
import script from "./ChartPeriodMenu.vue?vue&type=script&lang=ts"
export * from "./ChartPeriodMenu.vue?vue&type=script&lang=ts"
import style0 from "./ChartPeriodMenu.vue?vue&type=style&index=0&id=4ffd79a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd79a2",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/user-search-result.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fchart%2FChartPeriodMenu.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports